import { RouteConfig } from 'vue-router'

const Topology = () => import('@/nms/pages/topology/topology.vue')
const Location = () => import('@/nms/pages/location/location.vue')
const Service = () => import('@/nms/pages/services/service.vue')
const Cabinet = () => import('@/nms/pages/cabinet/cabinet.vue')

const routes: RouteConfig[] = [
  {
    path: '/topology',
    name: 'topology',
    meta: {
      sidebar: 'topology',
    },
    component: Topology,
  },
  {
    path: '/objects',
    name: 'objects',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/service',
    name: 'objects_service',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Service,
  },
  {
    path: '/objects/location',
    name: 'objects_location',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/zone',
    name: 'objects_zone',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/subzone',
    name: 'objects_subzone',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/area',
    name: 'objects_area',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/facility',
    name: 'objects_facility',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/building',
    name: 'objects_building',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/floor',
    name: 'objects_floor',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/room',
    name: 'objects_room',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/device',
    name: 'objects_device',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    component: Location,
  },
  {
    path: '/objects/cabinet',
    name: 'objects_cabinet',
    meta: {
      sidebar: 'objects',
      toolbar: 'objects',
    },
    props: {
      test: 'test',
    },
    component: Cabinet,
  },
]

export default routes